// DeleteUserModal.js
import { Modal, Button, Flex } from "antd";
import { ExclamationCircleFilled } from "@ant-design/icons";
import "./DeleteUserModal.scss";
import { ReactComponent as ExclamationIcon } from "../../../assets/Icons/ExclamationIcon.svg";
import NormalButton from "../../../Reuseable/NormalButton/NormalButton";

const DeleteUserModal = ({
  open,
  onClose,
  onDelete,
  message,
  loading = false,
  userStatus,
  /* This dialog was written for the enable/disable toggle, so every other
     caller - deleting a target, a rule, a product - got an "Enable" button.
     These let a caller name its own action without touching that default. */
  confirmLabel,
  danger,
}) => {
  const isDisable = userStatus === "Active";
  const isDanger = danger ?? isDisable;
  const actionLabel = confirmLabel || (isDisable ? "Disable" : "Enable");

  return (
    <Modal
      open={open}
      onCancel={onClose}
      footer={null}
      closable={false}
      // width={224}
      centered
      className="deleteUserModal"
    >
      <div
        className={`deleteModalContent ${isDanger ? "is-disable" : "is-enable"}`}
      >
        <span className="deleteModalIcon">
          <ExclamationIcon />
        </span>

        <h3 className="main-content">
          {message || `${isDisable ? "Disable" : "Enable"} this user?`}
        </h3>

        {!message && (
          <p className="deleteModalNote">
            {userStatus === "Active"
              ? "They will lose access immediately. You can enable them again at any time."
              : "They will regain access straight away with their previous permissions."}
          </p>
        )}

        {/* Cancel sits first so the destructive action is never the default
            landing spot for a stray click. */}
        <div className="deleteModalActions">
          <NormalButton type="default" className="cancelBtn" onClick={onClose}>
            Cancel
          </NormalButton>
          <Button
            type="primary"
            danger={isDanger}
            className="deleteBtn"
            onClick={onDelete}
            loading={loading}
          >
            {actionLabel}
          </Button>
        </div>
      </div>
    </Modal>
  );
};

export default DeleteUserModal;
